import { Permissions } from '@app/core/guard/Permissions';
import { PermissionGroup } from '@interfaces/a-organizar/permissionGroup';

/**
 * Os grupos de permissão marcados para o usuário editado dão `MARKETMONITOR_VIEW`? (card 3617)
 *
 * Decide se a seção Mercado (Relatório Semanal de Mercado) aparece nas preferências do cadastro de
 * usuário. O backend recusa ligar o relatório sem essa permissão, então mostrar a opção a quem não
 * tem seria um botão que só dá erro. Procura o grupo marcado em todas as listas conhecidas (grupos
 * do tipo, de TENANT, de ADMIN e os que vieram no próprio usuário). Grupo sem a lista de
 * permissões conta como "não dá": na dúvida, a seção fica escondida.
 */
export function selectedGroupsGrantMarketMonitorView(
  selectedGroupIds: readonly string[] | null | undefined,
  ...groupLists: (readonly PermissionGroup[] | null | undefined)[]
): boolean {
  if (!selectedGroupIds?.length) return false;

  const selected = new Set(selectedGroupIds);
  return groupLists.some(groups =>
    (groups ?? []).some(
      group =>
        selected.has(group.id) && (group.permissions ?? []).includes(Permissions.MarketMonitor.VIEW)
    )
  );
}
